import apiService from './api-service'

const savingsCutsService = {}

/**
 * Retrieve a savingsCuts by it's id
 * @param  array params (optional)
 * @return savingsCuts
 */
savingsCutsService.list = function (params) {
  return apiService.get(`/savings+cut`, { params }).then(res => res.data)
}

/**
 * Retrieve a savingsCuts by it's id
 * @param  int id
 * @param  array params (optional)
 * @return savingsCuts
 */
savingsCutsService.getById = function (id, params) {
  return apiService.get(`/savings+cut/${id}`, { params }).then(res => res.data)
}

/**
 * Update a savingsCuts by it's id
 * @param  int id
 * @param  array params (optional)
 * @return savingsCuts
 */
savingsCutsService.updateById = function (id) {
  return apiService.put(`/savings+cut/${id}`).then(res => res.data)
}

/**
 * Create a savingsCuts by it's id
 * @param  objet body
 * @return savingsCuts
 */
savingsCutsService.post = function (body) {
  return apiService.post(`/savings+cut`, body).then(res => res.data)
}

/**
 * Generate Statements
 * @param  objet body
 * @return savingsCut
 */

savingsCutsService.generateStatements = function (id, body) {
  return apiService.post(`/savings+cut/${id}/generateStatements`, body).then(res => res.data)
}

/**
 * Send Statements
 * @param  objet body
 * @return savingsCut
 */

savingsCutsService.sendStatements = function (id, body) {
  return apiService.post(`/savings+cut/${id}/sendStatements`, body).then(res => res.data)
}

/**
 * Complete savingsCuts
 * @param  objet body
 * @return savingsCut
 */
savingsCutsService.complete = function (id) {
  return apiService.post(`/savings+cut/${id}/complete`).then(res => res.data)
}

/**
 * Get Mailing Log records
 * @param  objet body
 * @return savingsCut
 */

savingsCutsService.getLogs = function (id) {
  return apiService.get(`/savings+cut/${id}/getMailingLog`).then(res => res.data)
}

/**
 * Get Investors records
 * @param  objet body
 * @return savingsCut
 */

/*
savingsCutsService.getInvestors = function (id) {
  return apiService.get(`/savings+cut/${id}/investors`).then(res => res.data)
}
*/

/**
 * Get Attachments records
 * @param  objet body
 * @return savingsCut
 */
savingsCutsService.getAccounts = function (id) {
  return apiService.get(`/savings+cut/${id}/accounts`).then(res => res.data)
}

/**
 * Get Payments records
 * @param  objet body
 * @return savingsCut
 */
/*
savingsCutsService.getPayments = function (id) {
  return apiService.get(`/savings+cut/${id}/payments`).then(res => res.data)
}
*/

/**
 * Get Dispersion Txt File
 * @param  objet body
 * @return savingsCut
 */
/*
savingsCutsService.getDispersion = function (id) {
  return apiService.get(`/savings+cut/${id}/getDispersion`).then(res => res.data)
}
*/

/**
 * Get Dispersion Txt File
 * @param  objet body
 * @return savingsCut
 */

/*
savingsCutsService.getDispersionInter = function (id) {
  return apiService.get(`/savings+cut/${id}/getDispersionInter`).then(res => res.data)
}
*/

/**
 * Get Mailing Log records
 * @param  objet body
 * @return savingsCut
 */

/*
savingsCutsService.getLogs = function (id) {
  return apiService.get(`/savings+cut/${id}/getMailingLog`).then(res => res.data)
}
*/

savingsCutsService.getMonthlyCutReport = function (id) {
  return apiService.get(`/report-savingsCut/${id}`).then(res => res.data)
}

savingsCutsService.getStatement = function (id) {
  return apiService.get(`/statement-savingsCut/${id}`).then(res => res.data)
}

export default savingsCutsService



// WEBPACK FOOTER //
// ./src/services/savings_cuts.js